import React from "react"
import { Layout } from "../components/Layout/Layout"
import { graphql } from "gatsby"
import { PageTitle } from "../components/PageTitle/PageTitle"
import { EversportsWidget } from "../components/EversportsWidget"
import { EVERSPORTS_IDS } from "../config/eversportsWidgets"

interface CourseBookingProps {
  data: {
    cms: {
      page: {
        title: string
      }
    }
  }
}

export const CourseBooking: React.FC<CourseBookingProps> = ({ data }) => {
  return (
    <Layout withPadding>
      <PageTitle>{data.cms.page.title}</PageTitle>
      {/*
        Eversports Widget — Course Booking / Schedule (Kursplan)
        OLD widget ID/URL: t4ez9i → https://www.eversports.de/widget/w/t4ez9i
        NEW widget ID: TODO — fill in from Eversports Manager > Settings > Widgets [NEW]
        Page: /course-booking (CMS page /kursplan)
      */}
      <EversportsWidget
        widgetId={EVERSPORTS_IDS.COURSE_BOOKING}
        label="course schedule"
        className="w-11/12 bg-white px-8 py-6"
      />
    </Layout>
  )
}

export default CourseBooking

export const query = graphql`
  {
    cms {
      page(id: "/kursplan", idType: URI) {
        title
      }
    }
  }
`
